// extracted by mini-css-extract-plugin
export default {"creditCard":"NM-z","expired":"OM-z"};